export default [
  {
    name: 'Onedev.studio',
    date: '03/2018',
    online: false,
    opensource: false,
    repo: '#',
    image: 'onedev.studio.png',
    url: '#',
    description: `Onedev.studio é um estúdio de Design, Front-end e Desenvolvimento WordPress. Feito com Stylus e Nuxtjs (Vuejs), usando pré-rendering e hospedado no Netlify.`,
    tags: [
      'WordPress',
      'Responsive',
      'Vuejs',
      'Nuxjs',
      'Netlify'
    ]
  },
  {
    name: 'OGG Digital',
    date: '03/2018',
    online: true,
    opensource: false,
    repo: '#',
    image: 'oggdigital.com.br.png',
    url: 'http://www.oggdigital.com.br',
    description: `Customização do site institucional da OGG Digital utilizando o tema OnePress como base.`,
    tags: [
      'Institucional',
      'FrontEnd',
      'UXDesign',
      'WordPressTheme',
      'WordPressCustom',
      'WordPress'
    ]
  },
  {
    name: 'GRGIT - Recursos Humanos',
    date: '02/2018',
    online: true,
    opensource: false,
    repo: '#',
    image: 'grgit.com.br.png',
    url: 'http://www.grgit.com.br',
    description: `Desenhado no Sketch o site institucional da GRGIT Recursos Humanos foi desenvolvido com WordPress`,
    tags: [
      'UXDesign',
      'SketchApp',
      'WordPress',
      'FrontEnd'
    ]
  },
  {
    name: 'WordPress nandomoreira.me',
    date: '11/2017',
    online: true,
    opensource: false,
    repo: '#',
    image: 'wordpress.nandomoreira.me.png',
    url: 'https://wordpress.nandomoreira.me',
    description: `Sites, blogs e lojas virtuais com WordPress em Curitiba. Converta seu HTML para WordPress, seu arquivo PSD para WordPress e seu arquivo Sketch para WordPress.`,
    tags: [
      'HTML2WordPress',
      'Sketch2WordPress',
      'PSD2WordPress',
      'FrontEnd'
    ]
  },
  {
    name: 'Participação do desenvolvimento front-end do Webapp Beholddy',
    date: '04/2017',
    online: true,
    opensource: false,
    repo: '#',
    image: 'beholddy-app.png',
    url: 'https://beholddy.com',
    description: `Desenvolvimento inicial do front-end do Webapp Beholddy, feito em Ruby on Rails usando Bootstrap, SASS e jQuery.`,
    tags: [
      'Ruby',
      'RubyOnRails',
      'SASS',
      'Hackathon',
      'Webapp',
      'FrontEnd'
    ]
  },
  {
    name: 'Site da Pizzaria Detroit',
    date: '12/2014',
    online: false,
    opensource: false,
    repo: '#',
    image: 'pizzariadetroit.com.br.png',
    url: '#',
    description: `Website institucional da Pizzaria Detroit, desenhado no Photoshop e desenvolvido com o CMS WordPress.`,
    tags: [
      'Photoshop',
      'WordPress',
      'Institucional',
      'Responsive'
    ]
  },
  {
    name: 'Site Icthus Instututo Multidisciplinar',
    date: '11/2014',
    online: false,
    opensource: false,
    repo: '#',
    image: 'icthus-odonto.png',
    url: '#',
    description: `Website institucional do Icthus Instututo Multidisciplinar, desenhado no Photoshop e desenvolvido com o CMS WordPress.`,
    tags: [
      'Photoshop',
      'WordPress',
      'Institucional'
    ]
  },
  {
    name: 'Site da Compatere - Soluções em Tecnologia',
    date: '11/2014',
    online: true,
    opensource: false,
    repo: '#',
    image: 'compatere.com.br.png',
    url: 'http://www.compatere.com.br',
    description: `Website institucional da Compatere Soluções em Tecnologia, desenhado no Photoshop e desenvolvido com o CMS WordPress.`,
    tags: [
      'Photoshop',
      'WordPress',
      'Institucional',
      'Bootstrap',
      'Responsive'
    ]
  },
  {
    name: 'Site Remer Terapias',
    date: '11/2014',
    online: true,
    opensource: false,
    repo: '#',
    image: 'remerterapias.png',
    url: 'https://www.remerterapias.com.br',
    description: `Website institucional e Blog do Terapeuta Rafael Remer, desenhado no Photoshop e desenvolvido com o CMS WordPress.`,
    tags: [
      'Voluntáriado',
      'Desenvolvimento',
      'Photoshop',
      'Blog',
      'WordPress',
      'Institucional',
      'Responsive'
    ]
  },
  {
    name: 'Site Irmãos Silva - Casas Pré Fabricadas',
    date: '10/2014',
    online: false,
    opensource: false,
    repo: '#',
    image: 'casas-irmaos-silva.png',
    url: '#',
    description: `Website institucional da empresa Irmãos Silva - Casas Pré Fabricadas, desenhado no Photoshop e desenvolvido com o CMS WordPress.`,
    tags: [
      'Photoshop',
      'UXDesign',
      'WordPress',
      'Institucional',
      'Frontend',
      'Bootstrap',
      'Responsive'
    ]
  },
  {
    name: 'Site da ONG Abracce.org.br',
    date: '10/2014',
    online: true,
    opensource: false,
    repo: '#',
    image: 'abracce.png',
    url: 'https://www.abracce.org.br',
    description: `Website Institucional da ONG Abracce, desenvolvido como voluntário, desenhado no Photoshop e desenvolvido com o CMS WordPress.`,
    tags: [
      'Voluntáriado',
      'Desenvolvimento',
      'Photoshop',
      'WordPress',
      'Institucional',
      'Responsive'
    ]
  },
  {
    name: 'Portal Conexão Plastilit',
    date: '10/2014',
    online: true,
    opensource: false,
    repo: '#',
    image: 'conexao-plastilit.png',
    url: 'http://www.conexaoplastilit.com.br',
    description: `Desenvolvimento do Portal Conexão Plastilit com o WordPress.`,
    tags: [
      'Desenvolvimento',
      'WordPress',
      'Portal'
    ]
  },
  {
    name: `Site Tomazoni`,
    date: '09/2014',
    online: true,
    opensource: false,
    repo: '#',
    image: 'tomasoni.ind.br.png',
    url: 'http://tomasoni.ind.br',
    description: `Website Institucional da Tomasoni Indústria de Máquias LTDA, desenhado no Photoshop e desenvolvido com o CMS WordPress.`,
    tags: [
      'Institucional',
      'WordPress',
      'Photoshop',
      'Responsive'
    ]
  },
  {
    name: `Site Divinu's Pães`,
    date: '06/2014',
    online: false,
    opensource: false,
    repo: '#',
    image: 'divinus-paes.png',
    url: '#',
    description: `Website Institucional da panificadora Divinu's Pães, desenhado no Photoshop e desenvolvido com o CMS WordPress.`,
    tags: [
      'Institucional',
      'WordPress',
      'Photoshop',
      'Responsive'
    ]
  },
  {
    name: 'Portal Macuxi.com',
    date: '06/2014',
    online: false,
    opensource: false,
    repo: '#',
    image: 'macuxi.com.png',
    url: '#',
    description: `Portal Macuxi.com, desenhado no Photoshop e desenvolvido com o CMS WordPress utilizando o recurso WPMU (WordPress Multisites).`,
    tags: [
      'WPPMU',
      'WordPress',
      'Photoshop',
      'Portal',
      'Responsive'
    ]
  },
  {
    name: 'Site da Hidrautest Indústria e Comércio de Ferramentas',
    date: '01/2014',
    online: true,
    opensource: false,
    repo: '#',
    image: 'hidrautest.com.br.png',
    url: 'https://www.hidrautest.com.br',
    description: `Website institucional da Hidrautest Indústria e Comércio de Ferramentas, desenhado no Photoshop e desenvolvido com o CMS WordPress.`,
    tags: [
      'WordPress',
      'Photoshop',
      'Institucional',
      'Responsive'
    ]
  }
]
